// @flow
import { getMessageBus, integrator } from './apis'
import { start, stop } from './widget'
import '../src/css/main.css'

function init(): void {
  const preventFo4Loading = !!window.MSInputMethodContext && !!document.documentMode
  if (preventFo4Loading) return

  const messageBus = getMessageBus()
  // Check if we have messageBus available
  if (!messageBus) {
    // This error cannot be sent to integrator
    throw Error('No messageBus available')
  }

  const { onStart, onStop, initSuccess, initError } = integrator(messageBus)

  try {
    onStart(start)
    onStop(stop)
    initSuccess()
  } catch (e) {
    initError(e)
  }
}

export { init }
